import React, { FC } from 'react';
import Image from 'next/image';
import stylesModule from './CandidateLayout.module.less';
import { Text } from '../../components/Typogrphy/Text';
import Logo from '../../public/logo.svg';
import FbIcon from '../../public/footer/facebook.svg';
import LinkedInIcon from '../../public/footer/linkedin.svg';
import InstagramIcon from '../../public/footer/instagram.svg';
import YoutubeIcon from '../../public/footer/youtube.svg';
import Link from 'next/link';
import Utils from '../../utils/Utils';

const styles: any = stylesModule;

export const CandidateFooter: FC = () => {
  return (
    <footer>
      <div className="w-full bg-gray flex flex-col items-center justify-center">
        {/*<div></div>*/}
        <div className="flex flex-col md:flex-row justify-between px-5 lg:px-16 pt-6 pb-6 gap-6 lg:gap-20 w-full max-w-[1440px]">
          <div className="flex flex-col gap-1 ">
            <Image
              className={styles.logo}
              src={Logo}
              alt={'Careers360 Logo'}
              width={185}
              height={43}
            />
            <div className={'lg:w-[233px]'}>
              <p className="!text-[#B2B2B2] text-lg my-0 lg:mt-5">
                Call now:{' '}
                <span className="text-[#5E6670] font-medium text-lg">
                  {' '}
                  +94&nbsp;727&nbsp;360&nbsp;360{' '}
                </span>
              </p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row w-full justify-between gap-6 md:gap-10 lg:gap-20 max-w-3xl mt:0 lg:mt-6 md:mt-0 mb-0 lg:mb-4">
            <div className="flex flex-col gap-3">
              <Text className="text-xl font-medium">HotJobs</Text>
              <Link className="text-base text-textGray" href="#">
                About Us
              </Link>
              <Link className="text-base text-textGray" href="#">
                Blog
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              <Text className="text-xl font-medium">Products</Text>
              <Link className="text-base text-textGray" href="#">
                Pricing
              </Link>
              <Link className="text-base text-textGray" href="#">
                Feature
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              <Text className="text-xl font-medium">Legal</Text>
              <Link className="text-base text-textGray" href="#">
                Terms of Service
              </Link>
              <Link className="text-base text-textGray" href="#">
                Privacy Policy
              </Link>
            </div>
            <div className="flex flex-col gap-3">
              <Text className="text-xl font-medium">Contacts</Text>
              <Link className="text-base text-textGray" href="#">
                Contact Us
              </Link>
              <Link className="text-base text-textGray" href="#">
                FAQ
              </Link>
            </div>
          </div>
        </div>
        <div className="bg-primary w-full flex justify-center text-white min-h-[44px]">
          <div className="w-full flex px-5 lg:px-16 max-w-[1440px] text-sm flex-col md:flex-row justify-between items-center">
            <div>@ 2025 HotJobs. All rights Reserved</div>
            <div className="flex items-center gap-5 my-1">
              <a href={Utils.getSocialMediaLink('fb')} target={'_blank'} rel="noreferrer">
                <Image src={FbIcon} width={10} alt={'Facebook Icon'} />
              </a>
              <a href={Utils.getSocialMediaLink('youtube')} target={'_blank'} rel="noreferrer">
                <Image src={YoutubeIcon} width={18} alt={'Youtube Icon'} />
              </a>
              <a href={Utils.getSocialMediaLink('ig')} target={'_blank'} rel="noreferrer">
                <Image src={InstagramIcon} width={18} alt={'Instagram Icon'} />
              </a>
              <a href={Utils.getSocialMediaLink('LinkedIn ')} target={'_blank'} rel="noreferrer">
                <Image src={LinkedInIcon} width={18} alt={'Linkedin Icon'} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
